"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sendEmail = void 0;
require("core-js/modules/es.json.stringify.js");
require("core-js/modules/es.promise.js");
const sendEmail = (name, email, subject, userMessage, api_url, website) => {
  return fetch(api_url, {
    mode: 'cors',
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      // eslint-disable-next-line no-undef
      authToken: process.env.REACT_APP_API_AUTH_KEY
    },
    body: JSON.stringify({
      name: name,
      email: email,
      subject: subject,
      message: userMessage,
      website: website
    })
  });
};
exports.sendEmail = sendEmail;